
export function generateTextMessageData(message, speaks = "bot",font) {
  let Defaultsayss = {
    speaks: speaks,
    font:font,
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}

export function generateWelcomeMessage(message="welcome", speaks = "welcome") {
  let Defaultsayss = {
    speaks: speaks,
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}
export function generateUserConfirmModel(message, speaks = "UserPrefrenceModal") {
  let Defaultsayss = {
    speaks: speaks,
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}
export function generateViewAccountDetails(message, speaks = "viewAccount") {
  let Defaultsayss = {
    speaks: speaks,
    type:"viewAccount",
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}
export function generateTermDepositEnquiry(message, speaks = "termDeposit") {
  let Defaultsayss = {
    speaks: speaks,
    type:"termDeposit",
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}

export function generateSCPform(message, speaks = "scp_form") {
  debugger
  let Defaultsayss = {
    speaks: speaks,
    type:"scp_form",
    msg: {
      text: {
        text: message,
      },
    },
  };
  return Defaultsayss;  
}



// Guided Menu for Type Menu
export function generateGuidedMenuMessageData(
  menuData,
  speaks = "bot1",
  targetId,
  font
  
) {
  console.log("...........message factiory",font)
  let guidedmenuSays = {
    type: "menu",
    speaks: speaks,
    id: targetId,
    font:font,
 
    msg: {
      data: menuData,
    },
  };
  return guidedmenuSays;
}

// Guided Menu for Type herocard
export function generateGuidedHeroCardMessageData(
  herocardData,
  // speaks = "bot",
  // speaks = "herocard",
  speaks = "bot1",
  // targetId
) {
  let guidedHeroCardSays = {
    type: "herocard",
    speaks: speaks,
    // id: targetId,
    msg: {
      data: herocardData,
    },
  };
  return guidedHeroCardSays;
}

export function generateAgrCardMessageData(
  herocardData,
  // speaks = "bot",
  // speaks = "herocard",
  speaks = "agrlink",
  // targetId
) {
  let guidedHeroCardSays = {
    type: "agrlink",
    speaks: speaks,
    // id: targetId,
    msg: {
      data: herocardData,
    },
  };
  return guidedHeroCardSays;
}

// nlp-qa card
export function generate_nlp_qa_MessageData(
  nlpqadata,
  query,
  speaks = "adya_nlp",
) {
  let adyaNlpSays = {
    type: "adya_nlp",
    speaks: speaks,
    msg: {
      userQuery: query,
      data: nlpqadata,
    },
  };
  return adyaNlpSays;
}

export function generateQuickMenuData(
  quickmenuData,
  speaks = "quickmenu",
) {
  let adsSays = {
    type: "quickmenu",
    speaks: speaks,
    msg: {
      data: quickmenuData,
    },
  };
  return adsSays;
}

// Advertisement Message Factory
export function generateAdvertisementData(
 
  adsData,
  speaks = "ads",
) {
   console.log("...........mess.",adsData)
  let adsSays = {
    type: "advertisement",
    speaks: speaks,
    msg: {
      data: adsData,
    },
  };
  return adsSays;
// // let Defaultsayss = {
// //   speaks: speaks,
// //   msg: {
// //     text: {
// //       text: message,
// //     },
// //   },
// // };
// // return Defaultsayss; 
}

// workflow data Message Factory
export function generateWorkflowData(
  workflowData,
  speaks = "workflow",
) {
  let workflowSays = {
    type: "workflow",
    speaks: speaks,
    msg: {
      data: workflowData,
    },
  };
  return workflowSays;
}
export function generateOtpValidation(message) {
  let workflowSays = {
    type: "otp",
    speaks: "otp",
    msg: {
      data: message,
    },
  };
  return workflowSays;
}

export function generateMobileValidation(message) {
  let workflowSays = {
    type: "mobile",
    speaks: "mobile",
    msg: {
      data: message,
    },
  };
  return workflowSays;
}
//agr workflow
export function generateAgrflowData(
  workflowData,
  speaks = "agr",
) {
  let workflowSays = {
    type: "agr",
    speaks: speaks,
    msg: {
      data: workflowData,
    },
  };
  return workflowSays;
}
export function generatesteflowData(
  workflowData,
  speaks = "ste",
) {
  let workflowSays = {
    type: "ste",
    speaks: speaks,
    msg: {
      data: workflowData,
    },
  };
  return workflowSays;
}
export function generateAgrflowDataDatepicker(
  workflowData,
  speaks = "agrDp",
) {
  let workflowSays = {
    type: "agrDp",
    speaks: speaks,
    msg: {
      data: workflowData,
    },
  };
  return workflowSays;
}
export function generateAgrflowDataDateRange(
  workflowData,
  speaks = "agrDr",
) {
  let workflowSays = {
    type: "agrDr",
    speaks: speaks,
    msg: {
      data: workflowData,
    },
  };
  return workflowSays;
}

// FAQ Menu data Message Factory
export function generateMenuFaqData(
  faqMenuData,
  speaks = "bot1",
) {
  let faqMenuSays = {
    type: "faqmenu",
    speaks: speaks,
    msg: {
      data: faqMenuData,
    },
  };
  return faqMenuSays;
}

export function generateIframeMessageData(
  video_url,
  iframeHeading = "Click here to open",
  speaks = "bot"
) {
  let iframeSays = {
    speaks: speaks,
    url: video_url,
    type: "iframe",
    hideMinWindow: true,
    text: iframeHeading,
  };

  return iframeSays;
}

export function generateDataCardMessageData(cardData) {
  let says = {
    speaks: "bot",
    datacard: cardData,
  };

  return says;
}


export function generateListMessagesData(
  listData,
  listHeading = "Here is the list"
) {
  let tableItems = listData[0];
  let data = listData;
  let columns = [];
  let keys = Object.keys(tableItems);

  for (let i = 0; i < keys.length; i++) {
    columns.push({
      title: keys[i],
      field: keys[i],
    });
  }

  // for (let count = 0; count < response.data.MESSAGE.BODY.length; count++) {
  for (let i = 0; i < listData.length; i++) {
    for (let j = 0; j < columns.length; j++) {
      let propName = columns[j].field;
      // data.push({
      //   propName : tableItems[i][columns[j].title]
      // })
      data[i][propName] = listData[i][columns[j].title];
    }
  }

  const tableData = {
    speak: "bot",
    type: "tableList",
    text: listHeading,
    columns,
    data,
  };

  return tableData;
}

export function generatePdfMessage(thumbnails, file_paths, type = "url") {
  return {
    speaks: "bot",
    msg: {
      files: thumbnails,
      url: "",
      file_path: file_paths,
      tableItems: [],
      filetype: type,
    },
    is_notification: false,
    from: "bot",
  };
}

export function generateFormMessage(formData, userQuery) {
  return {
    speaks: "bot",
    type: "form",
    formData: formData,
    userQuery: userQuery,
    formType: "leave_request",
  };
}

export function generateStatusCardMessage(cardItems) {
  return { statuscard: cardItems, speaks: "bot" };
}

export function generateDocumentCardMessage(cardData) {
  //Display Normal PDF
  if (cardData.BODY.length == 1) {
    let base64Array = cardData.BODY.map((str) =>
      str.data.slice(2, str.data.length - 1)
    );
    return generatePdfMessage(["Filename"], base64Array, "data");
  } else
    return {
      speaks: "bot",
      type: "DOC_SUGGESTIONS",
      suggestions: cardData.BODY.map((suggestion) => {
        return {
          headers: suggestion.headers,
          data: suggestion.data.slice(2, suggestion.data.length - 1),
        };
      }),
    };
}

export function generateBotTypingData(message, speaks = "bot") {
  let Defaultsayss = {
    speaks: "bot",
    typingBubble: true,
  };
  return Defaultsayss;
}

export function generateDetailedCardMessage(cardData) {
  //Display Normal PDF
  //   if(cardData.BODY.length == 1){
  //     let base64Array = cardData.BODY.map((str) =>
  //     str.data.slice(2, str.data.length - 1)
  //   );
  //  return  generatePdfMessage(["Filename"], base64Array, "data");
  //   }
  // else
  return {
    speaks: "bot",
    type: "WEB_SUGGESTIONS",
    suggestions: cardData.map((suggestion) => {
      return {
        main_title: suggestion.main_title,
        url: suggestion.url,
        title: suggestion.title,
        value: suggestion.value,
      };
    }),
  };
}

export function generateActionMessageData(actions, speaks = "bot") {
  let Defaultsays = {
    speaks: speaks,
    type: "actions",
    msg: {
      actions,
    },
  
  };
  return Defaultsays;
}
export function generateActionExitMessageData(actions, speaks = "exitflow") {
  let Defaultsays = {
    speaks: speaks,
    type: "actionss",
    msg: {
      actions,
    },
  
  };
  return Defaultsays;
}
export function generateActionCIFMessageData(actions, speaks = "cif") {
  let Defaultsays = {
    speaks: speaks,
    type: "CIF",
    msg: {
      actions,
    },
  
  };
  return Defaultsays;
}

export function generateAdyaActionMessageData(actions, speaks) {
  let Adyasays = {
    speaks: speaks,
    type: "adyaActions",
    msg: {
      actions,
    },
  };
  return Adyasays;
}
